import React, { useState, useEffect } from "react";
import axios from "axios";

import AuthenticatedTemplate from "../components/AuthenticatedTemplate";
import { SideBar } from "../components/SideBar";
import { FooterDashboard } from "../components/FooterDashboard";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import OrganisationCard from "../components/OrganisationCard";
import { formatDate } from "../utils/global";

function Section(props) {
  const [isOpen, setOpen] = useState(false);

  const toggle = () => {
    setOpen(!isOpen);
  };
  return (
    <div className="expandable-order">
      <div className="expandable-order__header" onClick={toggle}>
        <h3 className="paragraph-md semibold paragraph-md--dark">
          {props.title}
        </h3>
        <i
          className={"chevron-icon fas fa-chevron-" + (isOpen ? "up" : "down")}
        ></i>
      </div>

      {isOpen && (
        <div className="expandable-order__content">{props.children}</div>
      )}
    </div>
  );
}

export const DashboardOrders = () => {
  const [orderInProgress, setOrdersInProgress] = useState([]);
  const [ordersCompleted, setOrdersComplete] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [orderStatus, setOrderStatus] = useState({
    1: "In Progress",
    2: "Completed",
    3: "Cancelled",
  });

  const breadcrumbs = [
    {
      name: "Dashboard",
      path: "/dashboard-return",
    },
    {
      name: "Orders",
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      await fetchselectDashboardOrder();
    };

    fetchData();
  }, []);

  /**
   * Function to get the order by customer email
   */
  async function fetchselectDashboardOrder() {
    setLoadingOrders(true);
    try {
      // Retrieve email from Session storage
      const customerInfo = sessionStorage.getItem("LS_CUSTOMER_INFO");
      if (!customerInfo) {
        console.log("No customer info found in sessionStorage.");
        return;
      }
      const { email } = JSON.parse(customerInfo);
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/orders/select-orders`,
        {
          email,
        }
      );
      if (res.data !== null) {
        setOrdersInProgress(res.data[0]);
        setOrdersComplete(res.data[1]);
      }
    } catch (error) {
      console.log(error.response.data);
    } finally {
      setLoadingOrders(false);
    }
  }

  return (
    <>
      <AuthenticatedTemplate>
        <SideBar />
        <Header title="Orders" breadcrumbs={breadcrumbs} />

        <main className="dashboard">
          <div className="topic-title">
            <h1 className="text-sm text-neutral-950">Orders</h1>
            <Breadcrumbs items={breadcrumbs} />
          </div>

          <div className="dashboard-orders">
            <h2 className="paragraph-lg semibold text-neutral-950">
              In Progress
            </h2>
            {orderInProgress && orderInProgress.length ? (
              <div className="dashboard-orders__card">
                {orderInProgress.map((orderLine, index) => (
                  <Section title={`Order ${index + 1}`} key={`order-${index}`}>
                    <div className="dashboard-orders__header">
                      <p className="small text-neutral">
                        Order Number:{" "}
                        <span className="semibold text-neutral-950">
                          {orderLine.items[0].Order_ID}
                        </span>
                      </p>
                      <p className="small text-neutral">
                        Submission date:{" "}
                        <span className="semibold text-neutral-950">
                          {formatDate(
                            orderLine.items[0].Requested_Date,
                            "en-US",
                            "UTC"
                          )}
                        </span>
                      </p>
                      <p className="small text-neutral">
                        Status:{" "}
                        <span className="semibold text-neutral-950">
                          {orderStatus[orderLine.items[0].Order_Status]}
                        </span>
                      </p>
                    </div>

                    <div className="dashboard-organisations">
                      {orderLine.items.map((item, index) => {
                        return (
                          <OrganisationCard
                            key={index}
                            accountId={item.Account_ID}
                            status={item.Line_Status}
                            statusDescription={item.Line_Status_Descr}
                            name={item.Organisation_Name}
                            logo={item.Organisation_Logo_Path}
                          />
                        );
                      })}
                    </div>
                  </Section>
                ))}
              </div>
            ) : (
              <div className="paragraph-md">
                {loadingOrders ? "Loading..." : "No orders in progress."}
              </div>
            )}

            <h2 className="paragraph-lg semibold text-neutral-950">
              Completed Orders
            </h2>
            {ordersCompleted && ordersCompleted.length ? (
              <div className="dashboard-orders__card">
                {ordersCompleted.map((orderLine, index) => (
                  <Section
                    title={`Order ${index + 1}`}
                    key={`order-done-${index}`}
                  >
                    <div className="dashboard-organisations">
                      {orderLine.items.map((item, lineIndex) => {
                        return (
                          <OrganisationCard
                            key={lineIndex}
                            accountId={item.Account_ID}
                            status={item.Line_Status}
                            statusDescription={item.Line_Status_Descr}
                            name={item.Organisation_Name}
                            logo={item.Organisation_Logo_Path}
                            completed
                          />
                        );
                      })}
                    </div>
                  </Section>
                ))}
              </div>
            ) : (
              <div className="paragraph-md">
                {loadingOrders ? "Loading..." : "No orders completed."}
              </div>
            )}
          </div>
        </main>
        <FooterDashboard />
      </AuthenticatedTemplate>
    </>
  );
};
